import { render, staticRenderFns } from "./ViewSubOffice.vue?vue&type=template&id=0146461c&scoped=true&"
import script from "./ViewSubOffice.vue?vue&type=script&lang=js&"
export * from "./ViewSubOffice.vue?vue&type=script&lang=js&"
import style0 from "./ViewSubOffice.vue?vue&type=style&index=0&id=0146461c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146461c",
  null
  
)

export default component.exports